<div class="ui-dialog-container" style="width: 100%">
  <div class="ui-dialog-content" style="display: flex; align-items: center; flex-direction: column">
    <div class="spinner-container" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <ng-container *ngIf="!isLoading">
      <form
        [formGroup]="vitalSignform"
        style="display: flex; flex-wrap: wrap; gap: 30px; max-width: 900px; justify-content: center; margin-top: 1rem"
      >
        <div *ngFor="let vp of vitalProfilesDef" [ngSwitch]="vp.type">
          <mat-form-field *ngSwitchCase="'number'">
            <mat-label>
              {{ vp.nameDashboard ?? vp.nameMobile ?? null | getTranslation : vp.code : sessionService.userLang }}
              <ng-container *ngIf="vp.unit && (vp.unit | getTranslation : '' : sessionService.userLang) as unit">
                {{ unit ? "(" + unit + ")" : "" }}
              </ng-container>
            </mat-label>
            <input matInput [formControlName]="vp.code" />
            <mat-error *ngIf="vitalSignControls[vp.code]?.errors?.minValue">
              {{ "forms.errorMinValue" | translate }} ({{ vp | vitalSignRange }})
            </mat-error>
            <mat-error *ngIf="vitalSignControls[vp.code]?.errors?.maxValue">
              {{ "forms.errorMaxValue" | translate }} ({{ vp | vitalSignRange }})
            </mat-error>
            <mat-error
              *ngIf="
                vitalSignControls[vp.code]?.errors?.valueValidator &&
                !vitalSignControls[vp.code]?.errors?.minValue &&
                !vitalSignControls[vp.code]?.errors?.maxValue
              "
            >
              {{ "forms.checkValueFormat" | translate }}
            </mat-error>
          </mat-form-field>
          <div *ngSwitchCase="'array'" style="display: flex; align-items: center">
            <p>
              {{ vp.nameDashboard ?? vp.nameMobile ?? null | getTranslation : vp.code : sessionService.userLang }}
              <ng-container *ngIf="vp.unit && (vp.unit | getTranslation : '' : sessionService.userLang) as unit">
                {{ unit ? "(" + unit + ")" : "" }}
              </ng-container>
            </p>
            <button mat-icon-button matTooltip="{{ 'vitalSigns.viewArrayTooltip' | translate }}" (click)="openValueArrayDialog(vp)">
              <i class="fas fa-table"></i>
            </button>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
  <div class="ui-dialog-actions">
    <button mat-raised-button color="primary" (click)="save()" style="float: right" [disabled]="isLoading || !vitalSignform.valid">
      {{ (patientRegistrationService.isLastStep ? "model.patient.finish" : "globalHelp.nextSlide") | translate }}
    </button>
  </div>
</div>
